import { flattenSelectFieldMetadata, flattenFlexSubmissionData as sharedFlattenFlexSubmissionData } from "@captiva/shared-types";

export interface FieldTypeOption {
  value: string;
  label: string;
}

export const FIELD_TYPE_OPTIONS: FieldTypeOption[] = [
  { value: "text", label: "Text" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "datetime", label: "Date & Time" },
  { value: "time", label: "Time" },
  { value: "boolean", label: "Boolean (True/False)" },
  { value: "select", label: "Select (Single Option)" },
  { value: "multiSelect", label: "Select (Multiple Options)" },
  { value: "checklist", label: "Checklist" },
  { value: "checklistWithNotes", label: "Checklist With Notes" },
  { value: "signature", label: "Signature" },
  { value: "photo", label: "Photo" },
  { value: "multiPhoto", label: "Photos (Multiple)" },
  { value: "barcode", label: "Barcode Scan" },
  { value: "multiBarcode", label: "Barcode Scans (Multiple)" },
  { value: "gps", label: "GPS Location" },
  { value: "nfc", label: "NFC / RFID Scan" },
];

// Utility to get label from type
export function getFieldLabelFromType(type: string): string {
  const option = FIELD_TYPE_OPTIONS.find((opt) => opt.value === type);
  return option ? option.label : "Unknown";
}

const SAST_LOCALE = 'en-GB';
const SAST_TIMEZONE = 'Africa/Johannesburg';

export interface ChecklistItem {
  id: string | number;
  checked: boolean;
  label?: string;
  note?: string | number | null;
  metadata?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface FieldData {
  type: string;
  value: unknown;
  label?: string;
  metadata?: any;
}

export interface FlattenedChecklist {
  items: Array<ChecklistItem & { value: string | number }>;
  checkedItems: Array<ChecklistItem & { value: string | number }>;
  checkedIds: string[];
  checkedLabels: string;
  checkedCount: number;
  uncheckedCount: number;
  withNotes: Array<ChecklistItem & { value: string | number }>;
}

export function getFlattenedChecklistField(fieldData: FieldData): FlattenedChecklist {
  const items = Array.isArray(fieldData?.value) ? (fieldData.value as ChecklistItem[]) : [];
  const normalizedItems = items.map((item) => ({
    ...item,
    value: item?.id,
    ...(item?.metadata || {}),
  }));
  const checkedItems = normalizedItems.filter((item) => item?.checked);

  return {
    items: normalizedItems,
    checkedItems,
    checkedIds: checkedItems.map((item) => String(item.id)),
    checkedLabels: checkedItems.map((item) => item.label).filter(Boolean).join(', '),
    checkedCount: checkedItems.length,
    uncheckedCount: normalizedItems.length - checkedItems.length,
    withNotes: normalizedItems.filter(
      (item) => item.note !== undefined && item.note !== null && item.note !== ''
    ),
  };
}

export interface SubmissionData {
  id: string;
  documentNumber: string;
  templateName: string;
  submitterName: string;
  submitterEmail: string;
  submissionDate?: any;
  data: Record<string, FieldData>;
}

export function flattenFlexSubmissionData(data: SubmissionData): Record<string, any> {
  return sharedFlattenFlexSubmissionData(data);
}